<template>
  <div>

    <u-modal id="createServer" link="Создать сервер" title="Создать сервер" :isModalOpen="isModalOpen" @isModalOpen="isModalOpen = $event">
      <form @submit.prevent="newServer">
        <div class="mb-3">
          <label for="serviceName">Название</label>
          <input type="text" name="serviceName" v-model="formData.name" class="form-control" id="name">
        </div>
        <div class="mb-3">
          <label for="host">IP адрес</label>
          <input type="text" name="serviceName" v-model="formData.host" class="form-control" id="host">
        </div>
        <div class="mb-3">
          <label for="port">Порт</label>
          <input type="text" name="port" v-model="formData.port" class="form-control" id="port">
        </div>
        <div class="mb-3">
          <label for="port">Пользователь</label>
          <input type="text" name="user" v-model="formData.user" class="form-control" id="user">
        </div>
        <div class="mb-3">
          <label for="port">Пароль</label>
          <input type="text" name="password" v-model="formData.password" class="form-control" id="password">
        </div>
        <button type="submit" class="btn btn-primary">Создать</button>
      </form>
    </u-modal>
    <button type="submit" class="btn btn-primary" @click="isModalOpen=true">Создать сервер</button>
  </div>
</template>

<script setup>
import {ref} from "vue";

import {useServersStore} from '@/store/servers'
const serversStore = useServersStore()

// create server
const formData = ref({
  name: "",
  host: "",
  port: 22,
  user: "root",
  password: "",
})
const isModalOpen = ref(false)

async function newServer() {
  const server = await serversStore.create(formData.value)
  if(server === false) {
    return false
  }
  await serversStore.getList()
  isModalOpen.value = false
}

</script>
